import React from 'react'
import { TeaserProps } from '../teaser'
import { FirmTeaser } from '..'
import { Slider } from '../../ui/slider/Slider'
import { FirmCarousel } from '../../page/home/FirmCarousel/FirmCarousel'

export const OtherFirms = ({
  othersFirms,
  title,
}: {
  othersFirms: TeaserProps[]
  title: string
}) => {
  if (!othersFirms || othersFirms.length === 0) {
    return null
  }

  return (
    <div className="-mx-4 md:mx-0">
      <div className="space-y-4 md:space-y-6">
        <h4 className="ml-4 text-lg font-bold text-left md:ml-0 text-night lg:text-2xl">
          {title}
        </h4>

        <Slider additionnalClasses="md:hidden">
          {othersFirms.map((firm) => (
            <div key={firm.name} className="w-[240px] md:w-[280px] mx-3">
              <FirmTeaser {...firm} />
            </div>
          ))}
        </Slider>

        <div className="hidden -mx-64 md:block">
          <FirmCarousel firms={othersFirms} />
        </div>
      </div>
    </div>
  )
}
